





















import Vue from 'vue';
import Component from 'vue-class-component';
import {IDENTITY_SERVICE_INSTANCE} from '@/services/identity.service';
import {ROUTER_SERVICE} from '@/services/router.service';
import {NAVI_SERVICE_INSTANCE} from '@/services/navi.service';

@Component
export default class LogoutTemplate extends Vue {
  showDialog = true;

  created() {
    IDENTITY_SERVICE_INSTANCE.destroySession().finally(() => {
      NAVI_SERVICE_INSTANCE.clearNaviCache();
      ROUTER_SERVICE.resetProtectedRoutes();
      this.$router.replace('/login');
    });
  }
}
